<table *ngIf="data$ | async" mat-table [dataSource]="cutouts" class="w-full">
  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef i18n>Название</th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.name }}</td>
  </ng-container>

  <!-- X Column -->
  <ng-container matColumnDef="x">
    <th mat-header-cell *matHeaderCellDef i18n>x</th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.x }}</td>
  </ng-container>

  <!-- Y Column -->
  <ng-container matColumnDef="y">
    <th mat-header-cell *matHeaderCellDef i18n>y</th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.y }}</td>
  </ng-container>

  <!-- Height Column -->
  <ng-container matColumnDef="height">
    <th mat-header-cell *matHeaderCellDef i18n>Длина</th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.height }}</td>
  </ng-container>

  <!-- Width Column -->
  <ng-container matColumnDef="width">
    <th mat-header-cell *matHeaderCellDef i18n>Ширина</th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.width }}</td>
  </ng-container>

  <!-- Radius Column -->
  <ng-container matColumnDef="radius">
    <th mat-header-cell *matHeaderCellDef>
      <abbr
        i18n-title
        title="Радиус сопряжения"
        i18n="Radius of corner mating of rectangular cutout with rounding (abbr of 'Радиус сопряжения')"
        >РС</abbr
      >
    </th>
    <td mat-cell *matCellDef="let item" class="break-all">{{ item.radius }}</td>
  </ng-container>

  <!-- Base piont on panel Column -->
  <ng-container matColumnDef="panelBasePoint">
    <th mat-header-cell *matHeaderCellDef i18n>База</th>
    <td mat-cell *matCellDef="let item">
      <csl-base-point-thumbnail [active]="cutoutPoint2Position(item.angle)"></csl-base-point-thumbnail>
    </td>
  </ng-container>

  <!-- Base point on cutout -->
  <ng-container matColumnDef="cutoutBasePoint">
    <th mat-header-cell *matHeaderCellDef>
      <abbr i18n-title title="Точка привязки выреза" i18n="Cutout Anchor Point (abbr of 'Точка привязки выреза')"
        >ТПВ</abbr
      >
    </th>
    <td mat-cell *matCellDef="let item" class="break-all">
      <ng-container *ngIf="item.basePoint === thisCutoutPoint.Custom; else standardBasePoint"
        >({{ item.fragmentParams.x }};{{ item.fragmentParams.y }})</ng-container
      >
      <ng-template #standardBasePoint>
        <csl-base-point-thumbnail [showAxis]="false" [active]="cutoutPoint2Position(item.basePoint)">
        </csl-base-point-thumbnail>
      </ng-template>
    </td>
  </ng-container>

  <!-- delete column -->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="openWizard()" [disabled]="disabled" i18n-matTooltip matTooltip="Добавить вырез">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let item">
      <button mat-icon-button (click)="deleteCutout(item)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
